import { useState, useEffect, useContext } from "react";
import { MyContext } from "../context/UserProvider";
import SideBarUser from "./SideBar/sideBarUser";
import MeusPedidos from "./MeusPedidos/meusPedidos";
import MeusDados from "./MeusDados/meusDados";
import Enderecos from "./Endereco/enderecos";
import { FaArrowLeft } from "react-icons/fa";

export default function UserPageLayout({}) {
  const [windowDimensions, setWindowDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const isMobile = windowDimensions.width < 972;

  const {
    setShowUser,
    showLayoutMeusDados,
    setShowLayoutMeusDados,
    showLayoutEndereco,
    setShowLayoutEndereco,
    showLayoutNewEndereco,
    setShowLayoutNewEndereco,
    showLayoutEditEndereco,
    setShowLayoutEditEndereco,
    showPedidos,
    setShowPedidos,
    setShowSideBarUser,
    showSideBarUser,
  } = useContext(MyContext);

  const layouts = [
    { show: showLayoutEditEndereco, set: setShowLayoutEditEndereco, label: "Editar endereço" },
    { show: showLayoutNewEndereco, set: setShowLayoutNewEndereco, label: "Novo endereço" },
    { show: showLayoutEndereco, set: setShowLayoutEndereco, label: "Endereços" },
    { show: showLayoutMeusDados, set: setShowLayoutMeusDados, label: "Meus dados" },
    { show: showPedidos, set: setShowPedidos, label: "Meus pedidos" },
  ];

  const activeLayout = layouts.find((item) => item.show);
  const hasAnyOpenLayout = !!activeLayout;

  useEffect(() => {
    setShowSideBarUser(!(isMobile && hasAnyOpenLayout));
  }, [isMobile, hasAnyOpenLayout, setShowSideBarUser]);

  useEffect(() => {
    if (
      !isMobile &&
      !showLayoutEndereco &&
      !showLayoutNewEndereco &&
      !showLayoutEditEndereco &&
      !showPedidos
    ) {
      setShowLayoutMeusDados(true);
    }
  }, [
    isMobile,
    showLayoutEndereco,
    showLayoutNewEndereco,
    showLayoutEditEndereco,
    showPedidos,
    setShowLayoutMeusDados,
  ]);

  const voltar = () => {
    if (isMobile && showSideBarUser) {
      setShowUser(false);
      return;
    }

    if (activeLayout) {
      activeLayout.set(false);
      setShowSideBarUser(true);
      return;
    }

    setShowUser(false);
  };

  return (
    <div
      translate="no"
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 8 : 0,
        width: isMobile ? "100vw" : "600px",
        height: isMobile ? "100vh" : undefined,
        backgroundColor: "#fff",
        maxHeight: isMobile ? undefined : "25vh",
        padding: isMobile ? "16px" : "32px",
        marginTop: "16px",
        borderRadius: "12px",
      }}
    >
      {isMobile && (
        <button
          style={{
            width: "100%",
            alignSelf: "flex-start",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            padding: "10px 12px",
            marginLeft: "-4px",
            marginBottom: "6px",
            border: "1px solid #000000",
            borderRadius: "12px",
            backgroundColor: "#000000",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            cursor: "pointer",
            transition: "all 0.2s ease",
            color: "#ffffff",
            justifyContent:'space-between'
          }}
          onClick={voltar}
        >
          <FaArrowLeft size={16} color="#ffffff" />
          <span style={{ fontSize: "14px", fontWeight: 500 }}>
            {activeLayout?.label || 'Minha conta'}
          </span>
          <span style={{ width: 16 }}></span>
        </button>
      )}

      {showSideBarUser && (
        <div style={{ width: isMobile ? "100%" : "200px", margin: "0 auto" }}>
          <SideBarUser />
        </div>
      )}

      <div style={{ width: isMobile ? "100%" : "400px", margin: "0 auto" }}>
        {showLayoutMeusDados && <MeusDados />}
        {showLayoutEndereco && <Enderecos />}
        {showPedidos && (
          <MeusPedidos
            showPedidos={showPedidos}
            setShowPedidos={setShowPedidos}
            windowDimensions={windowDimensions}
            setShowUser={setShowUser}
          />
        )}
      </div>
    </div>
  );
}